import { CommonModule } from '@angular/common';
import {
  Component, HostListener, Signal, signal, input,
  inject,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterModule } from '@angular/router';

import { Language, LanguageService } from '@instaclause-webapp/shared-core';
import { InlineSvgComponent } from '@instaclause-webapp/shared-ui';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-ui-language',
  imports: [
    CommonModule,
    RouterModule,
    TranslocoModule,
    InlineSvgComponent,
  ],
  templateUrl: './language.component.html',
  styleUrl: './language.component.scss',
})
export class LanguageComponent {
  pagePosition = input.required<string>();
  languages: Signal<Language[]>;
  isOpenLanguages = signal<boolean>(false);
  currentLanguage: Signal<Language>;

  protected languageService = inject(LanguageService);
  private translocoService = inject(TranslocoService);

  constructor() {
    this.languages = this.languageService.languages;
    this.currentLanguage = toSignal(this.languageService.language$, {
      initialValue: (this.translocoService.getActiveLang() || 'en') as Language,
    });
  }

  @HostListener('document:click', [ '$event' ])
  onDocumentClick(event: MouseEvent): void {
    const targetElement = event.target as HTMLElement;
    const isClickedInsideList = targetElement.classList.contains('language-list');
    const isClickedInsideWrapper = targetElement.closest('.language-wrapper');

    if (!isClickedInsideList && !isClickedInsideWrapper && this.isOpenLanguages()) {
      this.isOpenLanguages.set(false);
    }
  }

  onChangeLanguage(language: Language): void {
    this.languageService.changeLanguage(language);
    this.isOpenLanguages.set(false);
  }

  onClickOpenLanguagePicker() {
    this.isOpenLanguages.set(!this.isOpenLanguages());
  }
}
